import { GridOn, TableRows } from "@mui/icons-material";
import { Button } from "@mui/material";

/**
 * @param {{
 *   view: 'table' | 'card',
 *   onViewChange: (nextView: 'table' | 'card') => void,
 * }} props
 */
function PricingReportViewToggle({ view, onViewChange }) {
  const isTableView = view === "table";
  const nextView = isTableView ? "card" : "table";
  const buttonLabel = isTableView ? "Card view" : "Table view";

  return (
    <Button
      variant="outlined"
      color="secondary"
      size="small"
      startIcon={isTableView ? <GridOn /> : <TableRows />}
      aria-label={isTableView ? "Switch to card view" : "Switch to table view"}
      aria-pressed={view === "card"}
      onClick={() => onViewChange(nextView)}
    >
      {buttonLabel}
    </Button>
  );
}

export default PricingReportViewToggle;
